<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCenter.supplier')" prop="supplierCode">
            <BjSelectLov v-model="queryParams.supplierCode" :placeholder="$t('QuotationCenter.supplier')" :option-list="supplierAllList" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCenter.logisticsChannel')" prop="logisticsChannelCode">
            <BjSelectLov v-model="queryParams.logisticsChannelCode" :placeholder="$t('QuotationCenter.logisticsChannel')" :option-list="logisticsChannelAllList" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCenter.status')" prop="status">
            <BjSelectLov v-model="queryParams.status" :placeholder="$t('QuotationCenter.status')" :option-list="statusList" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCenter.effectiveStatus')" prop="effective">
            <BjSelectLov v-model="queryParams.effective" :placeholder="$t('QuotationCenter.effectiveStatus')" :option-list="effectiveStatusList" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCenter.currency')" prop="currency">
            <BjSelectLov v-model="queryParams.currency" :placeholder="$t('QuotationCenter.currency')" :option-list="currencyList" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCenter.effectiveTime')" prop="effectiveTime">
            <BjDateRangePicker v-model="queryParamsTime_effectiveTime" :tip-show="true" :placeholder="$t('QuotationCenter.effectiveTime')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.remarkText')" prop="remark">
            <BjInput v-model="queryParams.remark" :placeholder="$t('table.remarkText')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button type="primary" plain @click="onAdd()">{{ $t('addText') }}</el-button>
          <el-button :disabled="tableOperationProp.notSelected || hasSelectedStatus(1)" type="primary" plain @click="onEnable()">{{ $t('enableText') }}</el-button>
          <el-button :disabled="tableOperationProp.notSelected || hasSelectedStatus(0)" type="primary" plain @click="onDisable()">{{ $t('QuotationCenter.status3') }}</el-button>
          <BjFrontendExport :disabled="tableOperationProp.notSelected" :label-list="labelList" :rows="selectedRows" file-name="Supplier Quotation.csv" type="primary" plain />
          <el-button v-permission:BusinessDeleteQuotationButton :disabled="tableOperationProp.notSelected" type="primary" plain @click="batchDelete()">{{ $t('bulkDelText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="col.prop == 'status'">
                <el-tag v-if="[0,1,2].includes(scope.row[col.prop])"
                  :type="scope.row[col.prop] == 1 ? 'success' : (scope.row[col.prop] == 2 ? 'warning' : 'info')">
                  {{ $t(statusList.bjGet(scope.row[col.prop])) }}
                </el-tag>
              </template>
              <template v-else-if="col.prop == 'effective'">
                <el-tag v-if="[0,1].includes(scope.row[col.prop])"
                  :type="scope.row[col.prop] == 1 ? 'success' : 'info'">
                  {{ scope.row[col.prop] == 1 ? $t('QuotationCenter.Active') : $t('QuotationCenter.Expired') }}
                </el-tag>
              </template>
              <template v-else>{{ scope.row[col.prop] | quotationTimeFilter(scope.row[col.prop]) }}</template>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <template>
                <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="edit-btn" @click="onCopy(props.row)">{{ $t('copyText') }}</el-button>
                <el-button type="text" class="delete-btn" @click="onView(props.row)">{{ $t('detailsText') }}</el-button>
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="550px" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="form" :model="form" label-position="top" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('QuotationCenter.supplier')" prop="supplierCode">
              <BjInput v-model="form.supplierName" :placeholder="$t('QuotationCenter.supplier')" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('QuotationCenter.logisticsChannel')" prop="logisticsChannelCode">
              <BjSelectLov v-model="form.logisticsChannelCode" :placeholder="$t('QuotationCenter.logisticsChannel')" :option-list="logisticsChannelList" @change="handleLogisticsChannelChange" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('QuotationCenter.currency')" prop="currency">
          <BjSelectLov v-model="form.currency" :placeholder="$t('QuotationCenter.currency')" :option-list="currencyList" />
        </el-form-item>
        <el-form-item :label="$t('QuotationCenter.effectiveTime')" prop="effectiveTime">
          <el-date-picker
            v-model="queryParamsTime_form_effectiveTime" prop="effectiveTime"
            class="full-width" format="dd/MM/yyyy HH:mm:ss"
            type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
            :start-placeholder="$t('form.startDateText')"
            :end-placeholder="$t('form.endDateText')"
            :default-time="['00:00:00', '23:59:59']"
          />
        </el-form-item>
        <el-form-item :label="$t('table.remarkText')" prop="remark">
          <BjInput v-model="form.remark" :placeholder="$t('inputText')" type="textarea" :rows="5" show-word-limit autosize maxlength="500" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="saveAmount()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { logisticApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';

const getDefaultForm = () => {
  return {
    supplierCode: null,
    supplierName: null,
    logisticsChannelCode: null,
    currency: null,
    startTime: null,
    endTime: null,
    remark: null,
  };
};

export default {
  name: 'BusinessQuotationSupplier',
  components: {},
  mixins: [pageMiXin],
  data() {
    const validateTime = (rule, value, callback) => {
      setTimeout(() => {
        if (!this.form.startTime || !this.form.endTime) {
          callback(new Error(this.$t('chooseText')));
        } else {
          callback();
        }
      }, 300);
    };
    const statusList = [
      { label: this.$t('QuotationCenter.status3'), value: 0 },
      { label: this.$t('QuotationCenter.status1'), value: 1 },
    ];
    const effectiveStatusList = [
      { label: this.$t('QuotationCenter.Expired'), value: 0 },
      { label: this.$t('QuotationCenter.Active'), value: 1 },
    ];
    return {
      colSpan: 4,
      selection: true,
      queryApi: logisticApi.getQuotesPageList,
      queryChangeTimer: null,
      isResettingQuery: false,
      queryParamsTime_effectiveTime: [],
      queryParamsTime_form_effectiveTime: [],
      queryParams: {
        supplierCode: null,
        logisticsChannelCode: null,
        startTime: '',
        endTime: '',
        status: null,
        effective: null,
        currency: null,
        remark: null,
      },
      statusList,
      effectiveStatusList,
      currencyList: [
        // 新增的时候默认 AUD
        { label: 'AUD', value: 'AUD' },
        { label: 'CNY', value: 'CNY' },
        { label: 'USD', value: 'USD' },
      ],
      labelList: [
        { label: 'ID', prop: 'quoteId', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.supplier'), prop: 'supplierName', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.logisticsChannel'), prop: 'logisticsChannelName', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.currency'), prop: 'currency', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.status'), prop: 'status', isCheck: true, disabled: false, export: { bjGet: statusList } },
        { label: this.$t('QuotationCenter.effectiveStatus'), prop: 'effective', isCheck: true, disabled: false, export: { bjGet: effectiveStatusList } },
        { label: this.$t('QuotationCenter.startTime'), prop: 'startTime', isCheck: true, disabled: false, width: 125, export: { type: 'date' } },
        { label: this.$t('QuotationCenter.endTime'), prop: 'endTime', isCheck: true, disabled: false, width: 125, export: { type: 'date' } },
        { label: this.$t('QuotationCenter.updateTime'), prop: 'lastUpdateDate', isCheck: true, disabled: false, width: 125, export: { type: 'date' } },
        { label: this.$t('QuotationCenter.creater'), prop: 'createdName', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.updateBy'), prop: 'lastUpdatedName', isCheck: true, disabled: false },
        { label: this.$t('table.remarkText'), prop: 'remark', isCheck: true, disabled: false, width: 120 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 160, export: false },
      ],
      supplierAllList: [],
      logisticsChannelAllList: [],

      // 弹窗相关数据
      dialogTitle: null,
      dialogFormVisible: false,
      form: getDefaultForm(),
      copyId: null,
      rules: {
        supplierCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        logisticsChannelCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        currency: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        effectiveTime: [{ required: true, validator: validateTime, trigger: 'change' }],
      },
      logisticsChannelList: [],
      copylogisticsChannelCode: null,
    };
  },
  watch: {
    queryParamsTime_effectiveTime(v) {
      this.queryParams.startTime = (v || [])[0];
      this.queryParams.endTime = (v || [])[1];
    },
    queryParamsTime_form_effectiveTime(v) {
      this.form.startTime = (v || [])[0];
      this.form.endTime = (v || [])[1];
    },
  },
  mounted() {
    // 获取供应商列表（查询条件用）
    logisticApi.getLogisticsCompany({}).then(res => {
      if (!res.failed) {
        this.supplierAllList = (res.content || []).map(item => ({
          label: item.name,
          value: item.id
        }));
      }
    });

    // 获取物流渠道列表（查询条件用）
    logisticApi.getLogisticsBusiness({}).then(res => {
      if (!res.failed) {
        this.logisticsChannelAllList = (res.content || []).map(item => ({
          label: item.name,
          value: item.id
        }));
      }
    });
  },
  methods: {
    // 获取弹窗编辑用的列表数据（新增、编辑、复制时调用）
    handleQuery() {
      if (this.isResettingQuery) return;
      clearTimeout(this.queryChangeTimer);
      this.queryChangeTimer = setTimeout(() => {
        this.reFresh();
      }, 300);
    },
    // 判断选中数据是否可以启用、停用
    hasSelectedStatus(status) {
      return this.selectedRows.some(item => String(item.status) === String(status));
    },
    getEditListData() {
      // 获取物流渠道列表（需传参数 csgEnableFlag=true）
      return logisticApi.getLogisticsBusiness({ csgEnableFlag: true }).then(res => {
        if (!res.failed) {
          this.logisticsChannelList = (res.content || []).map(item => ({
            label: item.name,
            value: item.id,
            companyId: item.companyId,
            companyName: item.companyName
          }));
        }
      });
    },
    hasOption(list, value) {
      if (value === null || value === undefined || value === '') {
        return false;
      }
      return list.some(item => String(item.value) === String(value));
    },
    setSupplierByLogisticsChannel(option, fallbackSupplierName = '') {
      this.form.supplierCode = option && option.companyId !== null && option.companyId !== undefined ? option.companyId : null;
      this.form.supplierName = option && option.companyName ? option.companyName : fallbackSupplierName;
    },
    handleLogisticsChannelChange(value, option) {
      const selectedLogisticsChannel = option || this.logisticsChannelList.find(item => String(item.value) === String(value));
      this.setSupplierByLogisticsChannel(selectedLogisticsChannel);
    },
    ensureCurrentFormOptions(row) {
      if (!this.hasOption(this.logisticsChannelList, row.logisticsChannelCode)) {
        this.form.logisticsChannelCode = null;
        this.setSupplierByLogisticsChannel(null);
        return;
      }
      const selectedLogisticsChannel = this.logisticsChannelList.find(item => String(item.value) === String(row.logisticsChannelCode));
      this.setSupplierByLogisticsChannel(selectedLogisticsChannel, row.supplierName);
    },
    getSubmitForm() {
      const form = {
        ...this.form,
      };
      delete form.supplierName;
      return form;
    },

    async onAdd() {
      await this.getEditListData();
      this.dialogTitle = this.$t('addText');
      this.copyId = null;
      this.copylogisticsChannelCode = null;
      this.form.currency = 'AUD'; // 币种新增时默认 AUD
      this.dialogFormVisible = true;
    },
    onEnable() {
      logisticApi.changeQuotesPageStatus({ids: this.selectedRows.map(e => e.id), status: 1}).then(res => {
        if (!res.failed) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
    onDisable() {
      logisticApi.changeQuotesPageStatus({ids: this.selectedRows.map(e => e.id), status: 0}).then(res => {
        if (!res.failed) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
    batchDelete() {
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          logisticApi.deleteQuotesPageList({ids: ids}).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          });
        })
        .catch(() => { });
    },

    async onEdit(row) {
      await this.getEditListData();
      this.dialogTitle = this.$t('editText');
      this.copyId = null;
      this.copylogisticsChannelCode = null;
      this.form = JSON.parse(JSON.stringify(row));
      // 确保当前表单的供应商和物流渠道在下拉列表中，如果不在则清空对应的值
      this.ensureCurrentFormOptions(row);
      this.queryParamsTime_form_effectiveTime = row.startTime && row.endTime ? [row.startTime, row.endTime] : [];
      this.dialogFormVisible = true;
    },
    async onCopy(row) {
      await this.getEditListData();
      this.dialogTitle = this.$t('copyText');
      this.copyId = row.id;
      this.copylogisticsChannelCode = row.logisticsChannelCode;
      this.form = JSON.parse(JSON.stringify(row));
      // 确保当前表单的供应商和物流渠道在下拉列表中，如果不在则清空对应的值
      this.ensureCurrentFormOptions(row);
      this.queryParamsTime_form_effectiveTime = row.startTime && row.endTime ? [row.startTime, row.endTime] : [];
      this.dialogFormVisible = true;
    },
    onView(row) {
      this.$router.push({ name: 'BusinessQuotationDetails', query: { id: row.id } });
    },

    // 保存弹窗数据 并 关闭编辑弹窗
    saveAmount() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const submitForm = this.getSubmitForm();
          if (this.dialogTitle == this.$t('addText')) {
            logisticApi.addQuotesPageList(submitForm).then(res => {
              if (!res.failed) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.handleClose();
                this.reFresh();
              }
            });
          } else if (this.dialogTitle == this.$t('copyText')) {
            if (String(this.form.logisticsChannelCode) === String(this.copylogisticsChannelCode)) {
              this.msgError(this.$t('QuotationCenter.copyTips'));
              return;
            }
            logisticApi.copyQuotesPageList({ ...submitForm, id: this.copyId }).then(res => {
              if (!res.failed) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.handleClose();
                this.reFresh();
              }
            });
          } else if (this.dialogTitle == this.$t('editText')) {
            logisticApi.editQuotesPageList(submitForm).then(res => {
              if (!res.failed) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.handleClose();
                this.reFresh();
              }
            });
          }
        }
      });
    },

    /** 关闭弹窗 清空数据 */
    handleClose() {
      this.form = getDefaultForm();
      this.copyId = null;
      this.copylogisticsChannelCode = null;
      this.queryParamsTime_form_effectiveTime = [];
      this.$refs.form.resetFields();
      this.dialogFormVisible = false;
    },

    /** 重置按钮操作 */
    beforeResetSearch() {
      this.isResettingQuery = true;
      clearTimeout(this.queryChangeTimer);
      this.queryParamsTime_effectiveTime = [];

      return new Promise(resolve => {
        this.$nextTick(() => {
          this.isResettingQuery = false;
          resolve();
        });
      });
    },
    // 清空选中数据 刷新表格数据 关闭所有标签页
    reFresh() {
      this.handleSelectionChange({});
      this.$refs.BjPage && this.$refs.BjPage.handleAllTagsClose();
      this.$refs.BjPage && this.$refs.BjPage.fetchData();
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}

.ts-divider {
  padding: 5px 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
</style>
